import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { AdminService } from "../../admin.service";

@Component({
  selector: 'app-edit-rms-bid',
  templateUrl: './edit-rms-bid.component.html',
  styleUrls: ['./edit-rms-bid.component.scss']
})
export class EditRmsBidComponent implements OnInit {

  public quoteForm: FormGroup;
  public moment: any;
  public loginName: string;
  public loginUserId: string;
  public addresses: any;
  public quoteId: number;
  public id: number;
  public bidDetails: any;
  public length: any;
  public totalCost: number = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public adminService: AdminService,
    private toastr: ToastrService,
    public router: Router
  ) {

  }

  ngOnInit(): void {
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'));
    this.quoteId = parseInt(this.activatedRoute.snapshot.paramMap.get('quoteId'));
    this.length = parseInt(this.activatedRoute.snapshot.paramMap.get('length'));
    this.getBidDetails(this.id, this.quoteId);
    this.moment = moment;
    this.loginName = localStorage.getItem('name');
    this.loginUserId = localStorage.getItem('id');
    this.getProfileDetails();
    this.getQuoteForm();
  }

  public getQuoteForm(): void {
    this.quoteForm = this.fb.group({
      'bidcode': [""],
      'deliverydate': [null],
      'customerid': [this.loginUserId],
      'shippingaddressid': [null],
      'supplierid': [0],
      "quantity": [0],
      "totalcost": [0],
      "taxes": [0],
      "totaltax": [0],
      "shipingcost": [10],
      "paymentmethodid": [0],
      "paymentstatusid": [0],
      "currencytypeid": [1],
      "contactperson": ["10"],
      "shipmenttermsid": [41],
      "paymenttermsid": [42],
      "loanid": [0],
      "insertype": ["23"],
      "salesrepid": [0],
      'bidItems': this.fb.array([])
    });

    this.addItemsArray();
  }

  public addItemsArray() {
    for (var i = 0; i < this.length; i++) {
      (this.quoteForm.get('bidItems') as FormArray).push(this.fb.group({
        "id": [null],
        "materialtypeid": [null],
        "mategrialdescription": [null],
        "quantity": [null],
        "targetdate": [null],
        "itemcost": [null],
        "priceperkg": [null],
        "comments": [null],
        "isactive": [null],
        "updatedBy": [this.loginUserId]
      }));
    }
  }

  getBidDetails(id, quoteid): void {
    this.adminService.getBidDetails(id, quoteid).subscribe(
      (res: any) => {
        const data = res.body.data;
        this.bidDetails = res.body.data;
        if (this.bidDetails.bidItems.length > 0)
          this.bidDetails.bidItems.forEach(element => {
            this.totalCost += parseFloat(element.itemcost);
          });
        this.quoteForm.patchValue(data);
      },
      err => {
        console.log(err);
      }
    );
  }

  getProfileDetails(): void {
    this.adminService.getUserProfileDetails().subscribe(
      (res: any) => {
        this.addresses = res.addresses;
      },
      err => {
        console.log(err);
      }
    );
  }

  changeItemCost(i: number, event: any) {
    console.log(event.target.value, i)
  }

  changeTaxAmount(event: any) {
    let amount = 0
    amount = (this.totalCost / 100) * event.target.value;
    this.quoteForm.patchValue({ taxes: amount })
  }

  saveQuote() {
    const quoteRequest = this.quoteForm.getRawValue();
    console.log(quoteRequest);
    quoteRequest.customerid = Number(quoteRequest.customerid);
    quoteRequest.shippingaddressid = Number(quoteRequest.shippingaddressid);
    quoteRequest.supplierid = Number(quoteRequest.supplierid);
    quoteRequest.shipingcost = Number(quoteRequest.shipingcost);
    quoteRequest.taxes = Number(quoteRequest.taxes);
    quoteRequest.totalcost = Number(quoteRequest.totalcost);
    quoteRequest.id = this.id;

    this.adminService.updateBidItems(this.id, this.quoteId, quoteRequest).subscribe(
      (res: any) => {
        if (res?.body?.status == 'success') {
          this.backQuotePage();
          this.toastr.success('Successfully created quotes');
        } else {
          this.toastr.error('Update Failed');
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  backQuotePage() {
    this.router.navigate(['/admin/procure']);
  }

}